import { render, staticRenderFns } from "./DataImportPurchases.vue?vue&type=template&id=54185d3a&scoped=true&"
import script from "./DataImportPurchases.vue?vue&type=script&lang=js&"
export * from "./DataImportPurchases.vue?vue&type=script&lang=js&"
import style0 from "./DataImportPurchases.vue?vue&type=style&index=0&id=54185d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54185d3a",
  null
  
)

export default component.exports